/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
export function downloadBase64File(base64Data, filename) {
    const element = document.createElement('a');
    element.setAttribute('href', base64Data);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export function base64StringtoFile(base64String, filename) {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

export function extractImageFileExtensionFromBase64(base64Data) {
    return base64Data.substring('data:image/'.length, base64Data.indexOf(';base64'));
}

export function image64toCanvasRef(canvasRef, image64, pixelCrop) {
    const image = new Image();
    image.src = image64;
    const canvas = canvasRef; // document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = (image.naturalWidth * pixelCrop.width) / 100;
    canvas.height = (image.naturalHeight * pixelCrop.height) / 100;
    canvas.x = (image.naturalWidth * pixelCrop.x) / 100;
    canvas.y = (image.naturalHeight * pixelCrop.y) / 100;

    image.onload = function () {
        ctx.drawImage(
            image,
            canvas.x,
            canvas.y,
            canvas.width,
            canvas.height,
            0,
            0,
            canvas.width,
            canvas.height
        );
    };
}

export const decimalPlace = (value, place = 2) => parseFloat(value);

export function titleCase(str) {
    return str
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substr(1).toLowerCase())
        .join(' ');
}
